// ImageField.js
import React from 'react';
import '../../styles/desktop/campoimagem.css';
import { useMediaQuery } from 'react-responsive';
import Loader from '../loader/loader';

function CampoImagem({ imagem, loadingImage }) {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    
    if (isMobile) {
        return null; // Não renderiza o componente em telas maiores
      }
    
  return (
    <div className='image-field'>
        {loadingImage && <Loader />}
        <img className='image' src={imagem} alt="Imagem" />
    </div>
    );
}

export default CampoImagem;